'use client';
import React from 'react';

export default function Footer() {
  return (
    <footer
      className="w-full"
      style={{ backgroundColor: '#1A2332', paddingTop: 'clamp(48px, 6vw, 96px)', paddingBottom: 'clamp(32px, 4vw, 56px)' }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 clamp(24px, 4vw, 64px)' }}>

        {/* Top row */}
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20" style={{ marginBottom: 'clamp(40px, 5vw, 64px)' }}>

          {/* Brand column */}
          <div style={{ flex: '0 0 auto', maxWidth: '340px' }}>
            <p
              style={{
                fontFamily: 'orpheus-pro, Georgia, serif',
                fontSize: 'clamp(18px, 1.8vw, 26px)',
                fontWeight: '400',
                color: '#E8D8D5',
                lineHeight: '1.4',
                marginBottom: '16px',
              }}
            >
              Dr Jennifer Morgan
            </p>
            <p
              style={{
                fontFamily: 'adobe-garamond-pro, Georgia, serif',
                fontSize: '14px',
                color: 'rgba(232,216,213,0.55)',
                lineHeight: '1.7',
                letterSpacing: '0.03em',
                marginBottom: '8px',
              }}
            >
              DClinPsy. CPsychol. HCPC Registered.
            </p>
            <p
              style={{
                fontFamily: 'adobe-garamond-pro, Georgia, serif',
                fontSize: '14px',
                color: 'rgba(232,216,213,0.55)',
                lineHeight: '1.7',
                marginBottom: '24px',
              }}
            >
              Consultant Clinical Psychologist in Private Practice.
            </p>
            <p
              style={{
                fontFamily: 'adobe-garamond-pro, Georgia, serif',
                fontSize: '13px',
                color: 'rgba(232,216,213,0.35)',
                letterSpacing: '0.06em',
                textTransform: 'uppercase',
              }}
            >
              Confidentiality assured.
            </p>
          </div>

          {/* Spacer */}
          <div className="hidden lg:block" style={{ flex: 1 }} />

          {/* Navigation columns */}
          <div className="flex flex-col sm:flex-row gap-10 sm:gap-16">
            <div>
              <p
                style={{
                  fontFamily: 'adobe-garamond-pro, Georgia, serif',
                  fontSize: '11px',
                  letterSpacing: '0.14em',
                  textTransform: 'uppercase',
                  color: 'rgba(232,216,213,0.35)',
                  marginBottom: '16px',
                }}
              >
                Practice
              </p>
              <nav className="flex flex-col gap-3">
                {[
                  { label: 'About Dr Morgan', href: '/about' },
                  { label: 'Concierge Care', href: '/services' },
                  { label: 'Psychological Services', href: '/psychological-services' },
                  { label: 'Treatment Stages', href: '/treatment-stages' },
                  { label: 'Enquiries & Fees', href: '/enquiries' },
                  { label: 'Questions & Answers', href: '/faq' },
                  { label: 'Arrange a Consultation', href: '/contact' },
                ].map(link => (
                  <a
                    key={link.href}
                    href={link.href}
                    style={{
                      fontFamily: 'adobe-garamond-pro, Georgia, serif',
                      fontSize: '15px',
                      color: 'rgba(232,216,213,0.65)',
                      textDecoration: 'none',
                      transition: 'color 0.2s ease',
                      lineHeight: '1.5',
                    }}
                    onMouseEnter={e => ((e.currentTarget as HTMLElement).style.color = '#E8D8D5')}
                    onMouseLeave={e => ((e.currentTarget as HTMLElement).style.color = 'rgba(232,216,213,0.65)')}
                  >
                    {link.label}
                  </a>
                ))}
              </nav>
            </div>

            <div>
              <p
                style={{
                  fontFamily: 'adobe-garamond-pro, Georgia, serif',
                  fontSize: '11px',
                  letterSpacing: '0.14em',
                  textTransform: 'uppercase',
                  color: 'rgba(232,216,213,0.35)',
                  marginBottom: '16px',
                }}
              >
                Legal
              </p>
              <nav className="flex flex-col gap-3">
                {[
                  { label: 'Fees & Enquiries', href: '/enquiries' },
                ].map(link => (
                  <a
                    key={link.href}
                    href={link.href}
                    style={{
                      fontFamily: 'adobe-garamond-pro, Georgia, serif',
                      fontSize: '15px',
                      color: 'rgba(232,216,213,0.65)',
                      textDecoration: 'none',
                      transition: 'color 0.2s ease',
                      lineHeight: '1.5',
                    }}
                    onMouseEnter={e => ((e.currentTarget as HTMLElement).style.color = '#E8D8D5')}
                    onMouseLeave={e => ((e.currentTarget as HTMLElement).style.color = 'rgba(232,216,213,0.65)')}
                  >
                    {link.label}
                  </a>
                ))}
              </nav>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div style={{ height: '1px', backgroundColor: 'rgba(232,216,213,0.1)', marginBottom: '28px' }} />

        {/* Bottom row */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p
            style={{
              fontFamily: 'adobe-garamond-pro, Georgia, serif',
              fontSize: '13px',
              color: 'rgba(232,216,213,0.3)',
            }}
          >
            &copy; {new Date().getFullYear()} Dr Jennifer Morgan. All rights reserved.
          </p>
          {/* LinkedIn */}
          <a
            href="https://www.linkedin.com"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            style={{ opacity: 0.4, transition: 'opacity 0.2s ease' }}
            onMouseEnter={e => ((e.currentTarget as HTMLElement).style.opacity = '0.8')}
            onMouseLeave={e => ((e.currentTarget as HTMLElement).style.opacity = '0.4')}
          >
            <svg viewBox="0 0 64 64" width="20" height="20" fill="#E8D8D5">
              <path d="M20.4,44h5.4V26.6h-5.4V44z M23.1,18c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1 c1.7,0,3.1-1.4,3.1-3.1C26.2,19.4,24.8,18,23.1,18z M39.5,26.2c-2.6,0-4.4,1.4-5.1,2.8h-0.1v-2.4h-5.2V44h5.4v-8.6 c0-2.3,0.4-4.5,3.2-4.5c2.8,0,2.8,2.6,2.8,4.6V44H46v-9.5C46,29.8,45,26.2,39.5,26.2z" />
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
}
